module.exports = __webpack_public_path__ + "img/dloons_04.cc6b2641.png";